import styled from 'styled-components'
import { media } from '../../../../utils/mediaQuery'

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  transition: all 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.light};
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`

export const CardHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 640px) {
    padding: 12px 14px;
    gap: 8px;
  }
`

export const HeaderTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`

export const TitleSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const ZoneName = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const ZoneId = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
`

export const MetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const Badge = styled.span<{
  $type?: 'status' | 'buildable' | 'overlay'
}>`
  display: inline-flex;
  align-items: center;
  padding: 3px 6px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  gap: 3px;

  ${({ $type, theme }) => {
    switch ($type) {
      case 'status':
        return `
          background: rgba(0, 173, 230, 0.1);
          color: ${theme.colors.primary};
        `
      case 'buildable':
        return `
          background: rgba(0, 179, 65, 0.1);
          color: ${theme.colors.success};
        `
      case 'overlay':
        return `
          background: rgba(255, 149, 0, 0.1);
          color: ${theme.colors.warning};
        `
      default:
        return `
          background: ${theme.colors.background.tertiary};
          color: ${theme.colors.text.secondary};
        `
    }
  }}
`

export const CardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 640px) {
    padding: 14px;
    gap: 16px;
  }
`

export const PurposeSection = styled.div`
  padding: 12px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`

export const PurposeTitle = styled.h4`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin: 0 0 6px 0;
`

export const PurposeText = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  ${media.tabletDown} {
    grid-template-columns: 1fr;
  }
`

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const DetailLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const DetailValue = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`
